import { makeStyles } from '@material-ui/core'

const FOOTER_HEIGHT = 60

const useStyles = makeStyles((theme) => ({
  footer: {
    height: FOOTER_HEIGHT,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 3),
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.divider}`,
    flexShrink: 0,
  },
  footerBtnBack: {
    textTransform: 'none',
    fontWeight: 500,
  },
  footerRight: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  footerBtnSendTest: {
    textTransform: 'none',
    fontWeight: 500,
  },
  footerPagination: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  footerPaginationLabel: {
    fontSize: 13,
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
  },
  footerPaginationArrow: {
    color: theme.palette.text.secondary,
  },
}))

export default useStyles
